import {ajaxRest} from './ajaxBase'

const CONTROLLER_PREFIX = 'datasource'

function getDataSource (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}${param}`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function getDataSourceType (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/type${param}`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function getDataSourceInfo (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/info${param}`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function updateDataSource (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}`,
      method: 'put',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function addDataSource (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}`,
      method: 'post',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function deleteDataSource (param) {
  let p = new Promise((resolve, reject) => {
    // console.log('come in')
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}`,
      method: 'delete',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function getPluginsInfo (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/info${param}`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function scanPlugins (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/api/plugins/scanAndRefreshPlugins`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function checkSourceConnection (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: param.url,
      method: 'GET',
      timeout: {client: 10 * 1000},
      pathPrefix: ''
    }
    ajaxRest(params).then(data => {
      console.log('checkSourceConnection data', data)
      resolve(data)
    }).catch(error => {
      console.log('checkSourceConnection error', error)
      reject(error)
    })
  })
  return p
}

function getCustomPluginsInfo (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/plugins/customPlugins${param}`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function deleteCustomPluginsInfo (param) {
  let p = new Promise((resolve, reject) => {
    // console.log('come in')
    let params
    params = {
      url: `/plugins/customPlugins`,
      method: 'delete',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function downloadDataSourcePlugins (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/plugins/downloadPlugins?fileName=${param.fileName}&org_id=${param.org_id}`,
      method: 'get',
      responseType: 'blob',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function exportConfig (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/config${param}`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function checkConfig (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/checkConfig`,
      method: 'Post',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

export default {
  getDataSource,
  updateDataSource,
  addDataSource,
  deleteDataSource,
  getDataSourceType,
  getDataSourceInfo,
  getPluginsInfo,
  scanPlugins,
  checkSourceConnection,
  getCustomPluginsInfo,
  deleteCustomPluginsInfo,
  downloadDataSourcePlugins,
  exportConfig,
  checkConfig
}



// WEBPACK FOOTER //
// ./src/api/dataSourceOrgAPI.js